/**
 * @internal
 */
export const getISOString = (dateTime: Date = new Date()): string => dateTime.toISOString()
